export enum Locale {
  English = 'en',
  Shqip = 'sq',
}

export type LocaleParams<T = unknown> = {
  params: Promise<{ locale: string } & T>
}
